import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onMounted, components, createVNode, render } from 'vue';
import Splash from './views/splash';
import FootNav from './components/FootNav';
import { getApiK, getVersionPrompt } from "@/api/login";
import toastComponent from '@/components/version/toast.vue';
export default {
  __name: 'App',
  setup(__props) {
    onMounted(() => {
      getApiKey();
      getVersion();
    });
    const getApiKey = () => {
      getApiK().then(res => {
        window.sessionStorage.setItem('apiK', JSON.stringify(res?.data));
      });
    };
    const getVersion = () => {
      getVersionPrompt().then(res => {
        if (res && res.code === 200 && res.data && res.data.id) {
          // this.version = res.data.version
          let versionId = res.data.id;
          let sysVersionPrompt = window.localStorage.getItem('SYS_VERSION_PROMPT');
          if (sysVersionPrompt && sysVersionPrompt == versionId) return;
          // 加入是否点击了不再提示操作按钮
          const toastDom = createVNode(toastComponent, {
            show: true,
            // 是否显示
            version: res.data.version,
            // 版本
            content: res.data.content,
            // 内容
            time: `${res.data.publishStartTime} 至 ${res.data.publishEndTime}`,
            duration: 300000,
            left: '0',
            top: '0',
            versionId: versionId
          });
          // 添加节点
          const divContainer = document.createElement('div');
          // 添加到容器中
          render(toastDom, divContainer); //将虚拟的dom变为真正的dom
          document.body.appendChild(divContainer); // 将真正的dom添加到dom树中
        }
      });
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_unref(FootNav))]);
    };
  }
};